import i18n from '@/languages' // internationalization
// 验证手机号码
export function checkPhoneNumber(rule, value, callback) {
  const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
  var mulValue;
  let mulValueTrue = true;
  if (!value) {
    return callback(new Error(i18n.t('rules.请填写手机号码！')))
  } else{
    // 判断是否多个手机号
    if(value.indexOf("，") > -1) {
      return callback(new Error(i18n.t("rules.请用英文逗号隔开")));
    }
    if(value.indexOf(",") > -1){
      mulValue = value.split(",");
    }
    // console.log(mulValue);
    if(Array.isArray(mulValue)){
      mulValue.forEach(element =>{
        if (!reg.test(element)) {
          // console.log(element);
          mulValueTrue = false;
          return callback(new Error(i18n.t('rules.请填写正确的手机号码！')))
        }else{
          // callback();
        }
      })
      if(mulValueTrue){
        callback();
      }
    } else if (!reg.test(value)) {
        return callback(new Error(i18n.t('rules.请填写正确的手机号码！')))
      }else{
        callback()
      }
  } 
}

export function checkIdNum(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (!value) {
    return callback(new Error(i18n.t('rules.证件号码不能为空')))
  } else if (!reg.test(value)) {
    return callback(new Error(i18n.t('rules.证件号码不正确')))
  } else {
    callback()
  }
}

// 验证数字值
export function checkNumber(rule, value, callback){
  if(!value){
    return callback(new Error(i18n.t("rules.不能为空或为0")))
  } else if(!Number.isInteger(value)){
    return callback(new Error(i18n.t("rules.需为整数")));
  }else{
    callback();
  }
}
// 验证 邮箱
export function checkMail(rule,value,callback){
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  var mulValue;
  if(!value){
    return callback(new Error(i18n.t("rules.邮件地址不能为空")))
  } else{
    // 判断是否多个邮件地址
    if(value.indexOf("，") > -1) {
      return callback(new Error(i18n.t("rules.请用英文逗号隔开")));
    }
    if(value.indexOf(",") > -1){
      mulValue = value.split(",");
    }
    // console.log(mulValue);
    if(Array.isArray(mulValue)){
      mulValue.forEach(element =>{
        if (!re.test(element)) {
          // console.log(element);
          return callback(new Error(i18n.t("rules.邮件地址不正确")));
        }else{
          // callback();
        }
      })
    } else if (!re.test(value)) {
        return callback(new Error(i18n.t("rules.邮件地址不正确")));
      }else{
        callback()
      }
  } 
}
export default {
  checkPhone: [{ required: true, validator: checkPhoneNumber, trigger: 'blur' }],
  checkId: [{ required: true, validator: checkIdNum, trigger: 'blur' }],
  checkNumber: [{required: true, validator: checkNumber, trigger: 'blur' }],
  checkMail: [{required: true, validator: checkMail, trigger: 'blur' }]
}